module.exports = __webpack_public_path__ + "img/zhszb98.f68a57bb.png";